import mapValues from 'lodash/mapValues';

export type NumericFormat =
  | 'formatInteger'
  | 'formatDecimalOneDigitMax'
  | 'formatDecimalOneDigitFixed'
  | 'formatDecimalTwoDigitsMax'
  | 'formatCompact'
  | 'formatMilliseconds'
  | 'formatPercentInteger'
  | 'formatPercentCompact'
  | 'formatPercentDecimalOneDigitMaxCompact'
  | 'formatPercentDecimalTwoDigitsMaxCompact'
  | 'formatPercentDecimalTwoDigitsMax';
export type NumericFormatters = Record<NumericFormat, (value: number) => string>;

const buildIntlFormatter = (
  lng: string | string[] | undefined,
  options: Intl.NumberFormatOptions,
) => {
  const formatter = new Intl.NumberFormat(lng, options);
  return formatter.format.bind(formatter);
};

const intlFormatOptions: Record<NumericFormat, Intl.NumberFormatOptions> = {
  formatInteger: { maximumFractionDigits: 0 },
  formatDecimalOneDigitMax: { maximumFractionDigits: 1 },
  formatDecimalOneDigitFixed: { maximumFractionDigits: 1, minimumFractionDigits: 1 },
  formatDecimalTwoDigitsMax: { maximumFractionDigits: 2 },
  formatCompact: { notation: 'compact' },
  formatMilliseconds: { style: 'unit', unit: 'millisecond' },
  formatPercentInteger: { style: 'percent' },
  formatPercentCompact: { style: 'percent', maximumFractionDigits: 0, notation: 'compact' },
  formatPercentDecimalOneDigitMaxCompact: {
    style: 'percent',
    maximumFractionDigits: 1,
    notation: 'compact',
  },
  formatPercentDecimalTwoDigitsMaxCompact: {
    style: 'percent',
    maximumFractionDigits: 2,
    notation: 'compact',
  },
  formatPercentDecimalTwoDigitsMax: { style: 'percent', maximumFractionDigits: 2 },
};

export const getNumericFormatters = (lng: string | string[] | undefined): NumericFormatters =>
  mapValues(intlFormatOptions, (options) => buildIntlFormatter(lng, options));
